import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import HeaderOne from "../../../common/header/HeaderOne";
import FooterOne from "../../../common/footer/FooterOne";

import herovideo from "../../../../src/app/assets/images/ivideo-media/bg-video.mp4";
import rickvideo from "../../../../src/app/assets/images/ivideo-media/rick-gif.mp4";
import glimpse1 from "../../../../src/app/assets/images/ivideo-media/glimpse1.mp4";
import glimpse2 from "../../../../src/app/assets/images/ivideo-media/glimpse2.mp4";
import glimpse3 from "../../../../src/app/assets/images/ivideo-media/glimpse3.mp4";

//import form
import FreesampleForm from"../Form/bookmeeting";

// brand logo imports

import c1 from "../../../app/assets/images/banner/c1.jpg";
import c2 from "../../../app/assets/images/banner/c2.jpg";
import c3 from "../../../app/assets/images/banner/c3.jpg";
import c4 from "../../../app/assets/images/banner/c4.jpg";
import c5 from "../../../app/assets/images/banner/c5.jpg";
import c6 from "../../../app/assets/images/banner/c6.jpg";
import c7 from "../../../app/assets/images/banner/c7.jpg";
import c8 from "../../../app/assets/images/banner/c8.jpg";
import c9 from "../../../app/assets/images/banner/c9.jpg";
import c10 from "../../../app/assets/images/banner/c10.jpg";
import c11 from "../../../app/assets/images/banner/c11.jpg";
import c12 from "../../../app/assets/images/banner/c12.jpg";
import c13 from "../../../app/assets/images/banner/c13.jpg";
import c14 from "../../../app/assets/images/banner/c14.jpg";
import c15 from "../../../app/assets/images/banner/c15.jpg";
import c16 from "../../../app/assets/images/banner/c16.jpg";
import c17 from "../../../app/assets/images/banner/c17.jpg";
import c19 from "../../../app/assets/images/banner/c19.jpg";
import c20 from "../../../app/assets/images/banner/c20.jpg";
import c21 from "../../../app/assets/images/banner/c21.png";
import c22 from "../../../app/assets/images/banner/c22.png";
import c23 from "../../../app/assets/images/banner/c23.png";
import c24 from "../../../app/assets/images/banner/c24.png";
import c25 from "../../../app/assets/images/banner/c25.png";
import c26 from "../../../app/assets/images/banner/c26.png";
import c27 from "../../../app/assets/images/banner/c27.png";
import c28 from "../../../app/assets/images/banner/c28.png";
import c29 from "../../../app/assets/images/banner/c29.png";
import c30 from "../../../app/assets/images/banner/c30.png";
import c31 from "../../../app/assets/images/banner/c31.png";
import blog1 from "../../../app/assets/images/ivideo-media/blog1.jpg";
import expert1 from "../../../app/assets/images/ivideo-media/expert-bg.jpg";

const products = () => {
const responsiveSettings = [
{
breakpoint: 768,
settings: {
slidesToShow: 3,
slidesToScroll: 3
}
},
{
breakpoint: 300,
settings: {
slidesToShow: 1,
slidesToScroll: 1
}
}
];
const properties = {
prevArrow: (
<button className="cs-btn btn-left">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"
    viewBox="0 0 16 16">
    <path fill-rule="evenodd"
      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
  </svg>
</button>
),
nextArrow: (
<button className="cs-btn btn-right">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
    viewBox="0 0 16 16">
    <path fill-rule="evenodd"
      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
  </svg>
</button>
),
};
return (
<div className="ivideo-page">
  <HeaderOne />
  <section class="d-flex align-items-center justify-content-center banner-sec ivideo-sec bg-img margin-minus">
    <div class="container custom-cn-width position-relative z-index-1">
      <div class="row g-4 justify-content-center align-items-">
        <div class="col-xxl-5 col-xl-6 col-lg-6 col-md-12 m-0 ms-xl-0 ps-md-5 px-xl-0 mt-4">
          <h2 class="pb-2 pe-lg-5 text-uppercas">
            Elevate your Brand's First Impression
          </h2>
          <p class="text-dark pe-lg-5 pb-2 font-size-19">
            Leveraging the immersive nature of video, businesses and
            individuals can craft narratives that resonate deeply, both
            emotionally and intellectually. With iVideo, you're not just
            presenting information; you're weaving a story that captivates
            and lingers long after the screen goes dark.
          </p>
          <a href="javascript;:" class="default-btn orange-btn  mt-4" data-bs-toggle="modal"
            data-bs-target="#FreesampleForm">
            Get a Free Sample
          </a>
        </div>
        <div class="col-xxl-7 col-xl-6 col-lg-6 col-md-12 ">
          <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
            <source src={herovideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center pb-0 section-padding">
    <div class="container custom-cn-width">
      <div class="row g-4 justify-content-center align-items-center">
        <div class="col-lg-8 col-md-8">
          <div class="sec-title b-r-6">
            <h1 class="mb-3">What’s an iVideo?</h1>
            <p class="pe-xl-5 font-size-17">
              iVideos are powerful introduction videos that change how
              businesses and individuals introduce themselves in a
              digitally-dominated world. With a comprehensive solution that
              tackles everything from scriptwriting to post-production,
              clients receive a polished iVideo that can instantly enhance
              your brand's perception and reach, and that can be easily
              shared in-person to clients, co-workers, or even in situations
              when you can’t pitch yourself face-to-face.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-start section-padding">
    <div class="container custom-cn-width">
      <div class="row justify-content-center align-items-center mb-lg-4 g-4">
        <div class="col-lg-6 col-md-8">
          <div class="design-block text-center text-lg-start ms-0 sec-title b-r-6">
            <h1 class="">The Power of Visual Storytelling</h1>
            <p class="mt-3">
              In our digitally-driven world, the potency of visual
              storytelling stands unparalleled. A well-crafted video can
              encapsulate a message far more compellingly than text alone.
              Our brains are naturally inclined towards visuals, with
              studies indicating that viewers retain a staggering 95% of a
              message from a video, in stark contrast to the mere 10% from
              text.
            </p>

            <a href="javascript;:" class="default-btn orange-btn  mt-4" data-bs-toggle="modal"
              data-bs-target="#FreesampleForm">
              Get a Free Sample
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-8 text-center">
          <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
            <source src={rickvideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </section>
  <section class="bg-light text-center section-padding">
    <div class="container custom-cn-width">
      <div class="row g-5 justify-content-center">
        <div class="col-xxl-7 col-xl-8 col-lg-10 col-md-10 mb-4 mb-lg-5">
          <h1 class="font-size-24">The iVideo Edge</h1>
          <p class="mt-3">
            Every brand has a story, but how you tell that story can make
            all the difference. Discover why iVideo is your ideal partner in
            this journey.
          </p>
        </div>
      </div>
      <div class="row g-4 justify-content-center">
        <div class="col-md-6 col-xl-4">
          <div class="features-item h-100 justify-content-start">
            <div
              class="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
              <svg className="fill-white w-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z" />
              </svg>
            </div>
            <h4 class="font-size-24">All-Inclusive Solution</h4>
            <p class="mt-3 font-size-17">
              {" "}
              From scriptwriting to post-production, experience a
              hassle-free process with polished end results.
            </p>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="features-item h-100 justify-content-start">
            <div
              class="icons mb-4 sec-primary-ic d-flex align-items-center justify-content-center mx-auto rounded-pill">
              <svg className="fill-white w-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z" />
              </svg>
            </div>
            <h4>Boost Your Brand</h4>
            <p class="mt-3 font-size-17">
              {" "}
              A premium video crafted by us can redefine your brand's
              perception and amplify its reach.
            </p>
          </div>
        </div>
        <div class="col-md-6 col-xl-4">
          <div class="features-item h-100 justify-content-start">
            <div class="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto gradient-blue rounded-pill">
              <svg className="fill-white w-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path
                  d="M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z" />
              </svg>
            </div>
            <h4 class="font-size-24">Share Instantly</h4>
            <p class="mt-3 font-size-17">
              Whether in a boardroom or a casual meetup, your video is just
              a QR scan away.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-start section-padding">
    <div class="container custom-cn-width">
      <div class="row justify-content-center align-items-center mb-lg-4 g-4">
        <div class="col-lg-6 col-md-8 order-lg-2">
          <div class="design-block  text-center text-lg-start  ms-0 sec-title b-r-6">
            <h1 class="">
              Our Expertise
            </h1>
            <p class="mt-3 font-size-17">
              Dive into the heart of what sets iVideo’s powerful
              introduction videos apart. We pride ourselves on meticulously
              crafted 1-3 minute intro videos that genuinely resonate with
              your brand's voice. Our team ensures a smooth process from the
              drafting of the initial script to delivering the final
              polished video. And understanding the importance of easy
              accessibility in today's fast-paced world, we've integrated QR
              codes with each video, ensuring that sharing your narrative is
              both quick and efficient.
            </p>

            <a href="javascript;:" class="default-btn orange-btn  mt-4" data-bs-toggle="modal"
              data-bs-target="#FreesampleForm">
              Get a Free Sample
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-8 text-center order-lg-1">
          <img src={expert1} alt="Logo" class="img-fluid b-r-6" />
        </div>
      </div>
    </div>
  </section>
  <section class="text-center section-padding pt-lg-0">
    <div class="container">
      <div class="row g-4 justify-content-center">
        <div class="col-xxl-8 col-xl-8 col-lg-10 col-md-10">
          <h5>Catch a Glimpse</h5>
          <h1 class=""> The iVideo Experience</h1>
          <p class="">
            Explore our demo iVideo to witness the impact of visual
            storytelling and its potential to revolutionize your brand's
            initial impact. This concise yet enthralling video provides a
            glimpse into the core essence of an iVideo, illustrating its
            ability to successfully introduce businesses and individuals in
            an era dominated by digital presence.
          </p>
        </div>
        <div class="col-lg-9">
          <div class="ratio ratio-16x9" id="rick-litzky">
            <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
              <source src={glimpse1} type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="ratio ratio-16x9" id="ganesh-shankar">
            <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
              <source src={glimpse2} type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="ratio ratio-16x9" id="amberwood-global">
            <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
              <source src={glimpse3} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section py-6 position-relative pt-0 section-padding">
    <div class="container custom-cn-width pricing">
      <div class="row">
        <div class="col text-center">
          <h1 class="">Pricing Plans</h1>
        </div>
      </div>

      <div class="row g-4 mt-1 justify-content-center">
        <div class="col-lg-6 col-xl-5">
          <div class="card border-0  h-100 bg-white shadow">
            <div class="bg-grey-pricing border-bottom p-5 text-center">
              <p class="">iVideo </p>
              <h5 class="my-0 h4 fw-bold">Essentials</h5>
              <h4 class="mb-0 d-flex align-items-center justify-content-center">
                <span class="fw-normal me-2 align-top">$</span>
                <span class="fw-bolder text-sp-primary display-4">299</span>
              </h4>
              <p class="mt-3 pt-2">
                Ideal for quick and impactful messages, the iVideo Basic
                package gets you:
              </p>
            </div>
            <div class="card-body text-center px-5">
              <ul class="list-unstyled mt-3 mb-0 text-start">
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>

                  <span>
                    <b>1-Minute Video*:</b> Crafted to capture attention and
                    deliver your message efficiently.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>Scriptwriting:</b> Our team composes a compelling
                    narrative to drive your point home.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>Full Editing:</b> Your footage, professionally cut,
                    refined, and pieced together to perfection.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>AI Voiceover:</b> Innovative technology gives your
                    video a modern and clear voice.
                  </span>
                </li>
              </ul>
            </div>
            <div class="border-top px-5 py-4 text-center">
              <p class="fw-bold">*$100 per additional minute.</p>
            </div>
            <div class="border-top p-5 pt-4 text-center">
              <p class="mb-4  fw-bold">
                Embark on your video creation journey with simplicity and
                quality.
              </p>
              <a href="#" class="default-btn" data-bs-toggle="modal" data-bs-target="#FreesampleForm">
                Get a Free Sample
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-5">
          <div class="card border-0 h-100 bg-white shadow position-relative">
            <div class="ribbon-content">
              <span class="ribbon bg-success shadow fw-bold">
                Recommended{" "}
              </span>
            </div>
            <div class="bg-grey-pricing border-bottom p-5 text-center">
              <p class="">iVideo </p>
              <h5 class="my-0 h4  fw-bold">Premium</h5>
              <h4 class="mb-0 d-flex align-items-center justify-content-center">
                <span class="fw-normal me-2 align-top">$</span>
                <span class="fw-bolder text-success display-4">499</span>
              </h4>
              <p class="mt-3 pt-2">
                Elevate your brand with the iVideo Premium package,
                featuring:
              </p>
            </div>
            <div class="card-body text-center px-5">
              <ul class="list-unstyled mt-3 mb-0 text-start">
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>1-Minute Video*:</b> Crafted to capture attention and
                    deliver your message efficiently.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>Scriptwriting:</b> Our team composes a compelling
                    narrative to drive your point home.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start border-bottom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>Full Editing:</b> Your footage, professionally cut,
                    refined, and pieced together to perfection.
                  </span>
                </li>
                <li class="py-2 d-flex align-items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-check-lg fill-success svg-fs" viewBox="0 0 16 16">
                    <path
                      d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                  </svg>
                  <span>
                    <b>Professional Voiceover:</b> Replace AI with the human
                    touch—a voice that resonates and engages, bringing
                    authenticity and warmth to your video.
                  </span>
                </li>
              </ul>
            </div>
            <div class="border-top px-5 py-4 text-center">
              <p class="fw-bold">*$239 per additional minute.</p>
            </div>
            <div class="border-top p-5 pt-4 text-center">
              <p class="mb-4  fw-bold">
                The Premium choice for those who seek to stand out with a
                more personal connection.
              </p>
              <a href="#" class="default-btn" data-bs-toggle="modal" data-bs-target="#FreesampleForm">
                Get a Free Sample
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section-padding pt-0 pb-0">
    <div class="container custom-cn-width">
      <div class="row g-xl-5 g-4 align-items-center justify-content-center text-center">
        <div class="col-xxl-8 col-xl-8 col-lg-9">
          <h1 class="mb-lg-4 mb-3">Discover the CAP Digisoft Difference</h1>
          <p class="px-xl-4 font-size-17">
            Our skilled and budget-friendly iVideo experts deliver top-tier
            solutions, enabling you to maximize your impact and enhance your
            competitive advantage.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center text-lg-start section-padding pb-lg-0">
    <div class="container custom-cn-width">
      <div class="cta-block ivideo-cta b-r-6">
        <div class="row g-xl-5 g-4 align-items-center justify-content-center">
          <div class="col-lg-9">
            <h2 class="font-size-34">
              Ready to transform your brand's introduction and make a
              lasting impact? Experience the iVideo difference now
            </h2>
          </div>
          <div class="col-lg-3 text-lg-end">
            <a href="javascript:;" class="default-btn " data-bs-toggle="modal" data-bs-target="#FreesampleForm">
              Get a Free Sample
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center client-block section-padding">
    <div class="container">
      <div class="row g-lg-5 g-4 justify-content-center">
        <div class="col-lg-12 mb-4 mb-lg-5">
          <h1 class="px-lg-4 ">
            Trusted by more than{" "}
            <span class="text-theme fw-bold text-grad">3000+</span> clients
            globally
          </h1>
        </div>
      </div>
      <Slide className="brand-slider" responsive={responsiveSettings} {...properties} slidesToScroll={1}
        slidesToShow={4} indicators={false} autoplay={true}>
        <div class="each-slide-effect">
          <img src={c1} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c2} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c3} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c4} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c5} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c6} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c7} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c8} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c9} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c10} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c11} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c12} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c13} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c14} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c15} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c16} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c17} alt="Logo" class="img-fluid mb-1" />
        </div>

        <div class="each-slide-effect">
          <img src={c19} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c20} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c21} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c22} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c23} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c24} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c25} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c26} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c27} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c28} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c29} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c30} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c31} alt="Logo" class="img-fluid mb-1" />
        </div>
      </Slide>
    </div>
  </section>
  <section class="other-sec pt-0 section-padding">
    <div class="container custom-cn-width">
      <div class="row g-5 text-center">
        <div class="col-lg-12 mb-lg-5 mb-4">
          <h1 class="">From our Blog</h1>
        </div>
      </div>
      <div class="">
        <div class="row g-4 g-xl-5 text-center text-xl-start justify-content-center">
          <div class="col-lg-9 col-md-6">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <img src={blog1} alt="Logo" class="img-fluid b-r-6" />
              </div>
              <div class="col-lg-6">
                <div class="d-flex flex-column h-100 justify-content-between py-1 mt-3 mt-lg-0">
                  <div class="">
                    <h6 class="mb-2 text-muted font-size-17">
                      Capturing Attention in Seconds&ZeroWidthSpace;
                    </h6>
                    <h4 class="mb-3 font-size-26">
                      The Transformative Power of Short Videos in Today's
                      Marketing Landscape
                    </h4>
                  </div>
                  <div>
                    <a class="d-inline-block underline-border" target="_blank"
                      href="https://capdigisoft.com/blog/the-transformative-power-of-short-videos-in-todays-marketing-landscape/">
                      <span class="border-line d-inline-block me-1">
                        Read more
                      </span>
                      <i class="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* Modal form */}

  <div className="modal fade" id="FreesampleForm" tabindex="-1" aria-labelledby="apply-modal" aria-hidden="true">
		<div className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">GET A FREE SAMPLE</h5>
					<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div className="modal-body p-4">
               <FreesampleForm/>     
					
				</div>
			</div>
		</div>
	   </div>

  <FooterOne />
</div>
);
};

export default products;